import { graphql, useFragment } from 'react-relay';
import serverVars from 'server-vars';
import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes.ts';
import { PRODUCT_PRICE_TYPES } from '../constants.ts';
import { type useImproveSalePriceDisplayAbTest_displayPrice$key } from './__generated__/useImproveSalePriceDisplayAbTest_displayPrice.graphql.ts';

const displayPriceFragment = graphql`
    fragment useImproveSalePriceDisplayAbTest_displayPrice on ItemDisplayPriceType {
        amountType
    }
`;

const TEST_NAME = 'Improve_sale_price_display';
let isAlreadyTracked = false;

type Props = {
    displayPrice: useImproveSalePriceDisplayAbTest_displayPrice$key | null | undefined;
};

export const useImproveSalePriceDisplayAbTest = ({
    displayPrice: displayPriceRef,
}: Props): {
    shouldImproveSalePriceDisplay: boolean;
    trackImproveSalePriceDisplayAbTest: () => void;
} => {
    const isClient = useClientState();
    const displayPrice = useFragment(displayPriceFragment, displayPriceRef);
    const { amountType } = displayPrice || {};
    const isEligible =
        isClient &&
        (amountType === PRODUCT_PRICE_TYPES.SALE || amountType === PRODUCT_PRICE_TYPES.NET) &&
        serverVars.get('abPageType') !== PAGE_TYPE.BUY;
    if (!isEligible) {
        return {
            shouldImproveSalePriceDisplay: false,
            trackImproveSalePriceDisplayAbTest: () => {},
        };
    }
    return {
        shouldImproveSalePriceDisplay: getAbTestV2(TEST_NAME)?.variant === 'variant',
        trackImproveSalePriceDisplayAbTest: () => {
            if (!isAlreadyTracked) {
                trackAbTestV2Variant(TEST_NAME);
                isAlreadyTracked = true;
            }
        },
    };
};
